/**
 * Returns the HTML for the app-level error fallback screen.
 * Used by both bootstrap.ts (pre-React) and RouteErrorFallback (React).
 */
export function getErrorFallbackHTML(): string {
  return `
    <style>
      .error-fallback-btn {
        background: transparent;
        border: 0.3rem solid rgba(255,255,255,0.7);
        border-radius: 0.8rem;
        color: white;
        cursor: pointer;
        font-size: 1.6rem;
        font-weight: 500;
        padding: 0.9rem 2.4rem;
        outline: none;
        transition: background-color 0.15s, border-color 0.15s, transform 0.15s;
      }
      .error-fallback-btn:focus {
        background-color: white;
        border-color: white;
        color: #111;
        transform: scale(1.08);
      }
    </style>
    <p style="font-size:2.4rem;margin-bottom:3rem">Something went wrong.</p>
    <button class="error-fallback-btn" onclick="location.replace('/?_r=' + Date.now())" autofocus>Reload App</button>
  `;
}
